// extracted by mini-css-extract-plugin
export default {"Password":"styles_Password__B7CDS"};